<template>
</template>
<script>
  import http from '../libs/http'
  import qs from 'qs'

  export default {
    data() {
      return {
        dataPages: {totalElements: 0, number: 0},
        dataCurrent: {},
        searchParams: {fuzzy: null},
        searching: false,
        searchApi: null,
      }
    },
    mounted() {
      this.search()
    },
    methods: {
      search(page) {
        if (typeof page !== 'number') {
          page = null
        }
        // 将page设置到地址路径的参数中, 这样刷新的时候能保持页码
        page = page || this.$route.query.page || 1;
        this.$router.push({
          path: this.$route.path,
          query: Object.assign({}, this.$route.query, {page: page})
        }).catch(() => {})

        // 前端的page是1开始, 后台参数是0开始
        const params = {
          page: page - 1
        }

        // 增加jsonConditions
        let conditions = []
        if (this.searchParams.fuzzy && this.searchParams.fuzzyParams) {
          let condition = {op: 'or', elements: []}
          for (let param of this.searchParams.fuzzyParams) {
            condition.elements.push({op: "contains", param: param, values: this.searchParams.fuzzy})
          }
          conditions.push(condition)
        }

        if (typeof this.searchConditions === 'function') {
          conditions = conditions.concat(this.searchConditions())
        }

        if (this.searchParams.params) {
          Object.assign(params, this.searchParams.params)
        }

        if (conditions.length) {
          params.jsonConditions = JSON.stringify({op: "and", elements: conditions})
        }

        // 增加排序, params.sort = ['sealType', 'code,desc']
        if (typeof this.searchSort === 'function') {
          params.sort = this.searchSort()
        }

        // 增加queryType
        if (typeof this.searchQueryType === 'function') {
          params.queryType = this.searchQueryType()
        }

        this.searching = true

        // sort参数重复出现的解决, 参考下段代码
        // post的时候：axios.post(url, qs.stringify(params: {ids: [1,2,3],type: 1}, {indices: false}))
        http.get(this.searchApi, {
          params: params,
          paramsSerializer: p => {return qs.stringify(p, {indices: false})}
        }).then(payload => this.dataPages = payload).finally(() => this.searching = false)
      },

      /**
       * 修改当前列表中的信息, 通常在修改或新增记录后用来更新当前列表
       * @param payload 记录新数据
       * @param primaryKey 记录的主键
       */
      changeCurrent(payload, primaryKey) {
        if (!primaryKey)
          primaryKey = 'id'

        this.dataCurrent = payload
        let pos = this.dataPages.content.findIndex((item) => {
          return item[primaryKey] === payload[primaryKey]
        })
        if (pos >= 0)
          this.dataPages.content.splice(pos, 1, payload)
        else
          this.dataPages.content.splice(0, 0, payload)
      },

      /**
       * 删除当前列表中第index个记录, 在后台删除记录后更新列表
       * @param index
       */
      deleteIndex(index) {
        this.dataPages.content.splice(index, 1)
      }
    }
  }
</script>
